import UIMessageContent from "./MessageDictionary"
import GeneralHelper from "./generalHelper"

//usage

//UIMessage.init$(Cx.Localization.Spanish).then(function() {
//  Cx.language(Cx.Localization.Spanish); 
//  Cx.Message(UIMessageContent.FAVORITES); //favoritos
//});

export default class UILocalizedMessage {
  static init$(target){

    Cx.Localization.setLanguage(target);

    let blobName = 'language';

    let languageSet = Cx.Localization.currentLanguage();
    let qs = { source: languageSet, target : target, content: UIMessageContent };
    
    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));
    let set = GeneralHelper.getPatternContainersFromLocalStorage(blobName, hash);

    if( !set && languageSet && languageSet !== Cx.Localization.ENGLISH ){

      return Cx.Localization.translateMessages$({
        messages: UIMessageContent.toArray(),
        languages: [target],
        srcLang: Cx.Localization.ENGLISH //UIMessageContent is defined in EN
      })
      .then(function (messageObj) {

        Cx.language.extend(messageObj);
        GeneralHelper.savePatternContainersToLocalStorage(blobName, hash, messageObj);

        return Cx.resolve();
      });
    }
    else{
      return Cx.resolve();
    }
  };
} 